import { paymentRequiredMessage } from '../../usage/admission-error.mjs';
import { isCachedReadDenial } from './cached-read-denial.mjs';
import { sdkErrorCode } from './tier0/sdk-error-contract.mjs';

/** Read only the actual typed server refusal. Upstream message/body fields
 * never supply App copy; the host's DESIGN mapper attaches that separately. */
export function runtimeErrorResponse(value, statusCode) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const error = value.error;
  const code = sdkErrorCode(error, null);
  if (code === null) return null;
  const detail = value.detail;
  return {
    code,
    ...paymentCopy(value, statusCode, code),
    ...(isCachedReadDenial({ code, statusCode }) ? { cacheDenied: true } : {}),
    retryable: typeof error.retryable === 'boolean' ? error.retryable : false,
    ...(detail && typeof detail === 'object' && !Array.isArray(detail) ? { details: detail } : {}),
  };
}

function paymentCopy(value, statusCode, code) {
  return code === 'payment_required' && statusCode === 402
    ? { userMessage: paymentRequiredMessage(value.reason) }
    : {};
}
